(function() {
    'use strict';
    angular
        .module('jotApp')
        .factory('TabDeviceReleases', TabDeviceReleases);

    TabDeviceReleases.$inject = ['$resource'];

    function TabDeviceReleases ($resource) {
        var resourceUrl =  'api/tab-device-releases/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    data = angular.fromJson(data);
                    return data;
                }
            },
            'getPage': {
                method: 'GET',
                isArray: true
            },
            'update': { method:'PUT' },
            'load': {
                url:'api/tab-device-releases/inactive',
                method: 'GET',
                isArray: true
            },
            'search': {
                url:'api/tab-device-releases/search',
                method: 'POST',
                isArray: true
            },
            'filterType': {
                url:'api/tab-device-releases/tab-devices/:deviceId',
                method: 'GET',
                isArray: true
            },
            'filterTypePage': {
                url:'api/tab-device-releases/tab-devices-page/:id',
                method: 'GET',
                isArray: true
            }
        });
    }
})();
